import { ReviewEntryStatus } from '../enums/reviewEntryStatus'
import type { ReviewEntryItem } from '../types/reviewEntryItem'
import type { ReviewEntryTableRow } from '../types/reviewEntryTableRow'
import { getReviewEntryId } from './getReviewEntryId'

interface GetSelectedEntryRowWithLiveStatusProps {
  items: ReviewEntryItem[]
  rows: ReviewEntryTableRow[]
  selectedEntryRow: ReviewEntryTableRow | null
}

export const getSelectedEntryRowWithLiveStatus = ({
  items,
  rows,
  selectedEntryRow,
}: GetSelectedEntryRowWithLiveStatusProps): ReviewEntryTableRow | null => {
  if (!selectedEntryRow) {
    return null
  }

  const liveRow = rows.find((row) => row.entryId === selectedEntryRow.entryId && row.showDocumentLevelFields)

  if (liveRow) {
    return liveRow
  }

  const liveItem = items.find((item, itemIndex) => getReviewEntryId(item, itemIndex) === selectedEntryRow.entryId)

  if (!liveItem) {
    if (items.length === 0) {
      return selectedEntryRow
    }

    return { ...selectedEntryRow, status: ReviewEntryStatus.Validated }
  }

  return {
    ...selectedEntryRow,
    status: liveItem.documentStatus ?? liveItem.status ?? selectedEntryRow.status,
  }
}
